//#region src/trigger_event_name.ts
var TriggerEventName = /* @__PURE__ */ function(TriggerEventName) {
	TriggerEventName["FirstLoad"] = "first-load";
	TriggerEventName["PreCheckout"] = "pre-checkout";
	TriggerEventName["CartView"] = "cart-view";
	TriggerEventName["ViewItem"] = "view-item";
	TriggerEventName["ViewModGroup"] = "view-mod-group";
	return TriggerEventName;
}(TriggerEventName || {});
var VitrineTriggerEventName = /* @__PURE__ */ function(VitrineTriggerEventName) {
	VitrineTriggerEventName["FirstLoad"] = "first-load";
	VitrineTriggerEventName["CartView"] = "cart-view";
	VitrineTriggerEventName["ViewItem"] = "view-item";
	VitrineTriggerEventName["ViewModGroup"] = "view-mod-group";
	VitrineTriggerEventName["PreCheckout"] = "pre-checkout";
	VitrineTriggerEventName["MenuSectionRecommendation"] = "menu-section-recommendation";
	return VitrineTriggerEventName;
}(VitrineTriggerEventName || {});
//#endregion
export { TriggerEventName, VitrineTriggerEventName };

//# sourceMappingURL=trigger_event_name.js.map